module.exports = __webpack_public_path__ + "static/media/ic_75px_General_Logo.c2eddda2.svg";